<script setup lang="ts">
// The inline "widget unavailable" placeholder (§14). It renders in two situations that look the
// same to a viewer: no feature registered this kind, and the registered chunk failed to load.
//
// It takes no props so `defineAsyncComponent`'s `errorComponent` can mount it directly — that slot
// passes an error/retry payload, not the widget, and a placeholder that needed the block's name
// could not be used there.
import { useI18n } from '@/shared/i18n'
import { Alert } from '@/shared/ui'

const { t } = useI18n()
</script>

<template>
  <Alert tone="info" class="dashboard-widget-unavailable m-sm">
    {{ t('dashboards.widget.unavailable') }}
  </Alert>
</template>
